module.exports = __webpack_public_path__ + "static/media/life-earn-point-banner-mobile.5674b4c1.jpg";